export { default } from './FooterInfo';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/FooterInfo/index.js